<template lang="pug">
div
    v-list-tile(v-for="(f,i) in filters" :key="f.id"
                @click="select(f)"
                :class="{'active-filter' : ((filter && filter.id === f.id) && ($route.name === 'TaskList' || $route.name === 'TaskController'))}"
                active-class="" ripple)
      v-list-tile-action.pl-0
        v-icon inbox
      v-list-tile-content
        v-list-tile-title {{ $tf(f.properties.description, f.name) }}
      v-chip.v-chip--x-small(color="red lighten-1" text-color="white" v-if="f.itemCount > 0") {{ f.itemCount }}
    
      //v-list-group(prepend-icon="inbox" no-action :value="$route.name === 'TaskList' || $route.name === 'TaskController'")
      //v-list-tile.task-list-tile(slot="activator"  @click="select(filters[0])")
        //v-list-tile-content
          //v-list-tile-title {{ $tf("drawer.task.filter.allTasks") }}
        //v-chip.v-chip--x-small(color="red lighten-1" text-color="white" v-if="total > 0") {{ total }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import lodash from 'lodash'

export default {
  name: 'TaskDrawer',

  data() {
    return {
      total: 0,
    }
  },

  computed: {
    ...mapGetters({
      filters: 'task/filters',
      filter: 'task/filter',
      groups: 'auth/groups',
    }),
    lastFilterIndex() {
      return this.filters.length - 1
    },
    isAdmin() {
      const result = lodash.some(this.groups, group => group.id == 'camunda-admin')
      return result
    },
  },

  watch: {
    'filters'(newFilters) {
      this.total = newFilters.reduce((acc, obj) => acc + obj.itemCount, 0)
    },
  },

  created() {
    this.getFilters()
  },

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
      getFilters: 'task/getFilters',
      selectFilter: 'task/selectFilter',
      getTasks: 'task/getTasks',
    }),

    select(filter) {
      this.selectFilter(filter).then(() => {
        if (!this.$vuetify.breakpoint.lgAndUp) {
          this.toggleDrawer()
        }
        if (this.$route.name === 'TaskList') {
          this.getTasks()
        } else {
          this.$router.push('/task-list')
        }
      })
    },
  },

}
</script>

<style lang="stylus">
/*.v-list__group__header--active
  .v-chip
    display none*/
.task-list-tile
  .v-list__tile
    padding-right 0
</style>



// WEBPACK FOOTER //
// src/components/task/TaskDrawer.vue